import React, { Fragment } from "react"
import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import PathogenSelection from './PathogenSelection'
import PathogenSpecificQuestions from './PathogenSpecificQuestions'
import { formatPathogenName } from '../reducers/infectionCourseFormReducer'
import { Button, Accordion, Card } from 'react-bootstrap'

const InfectionCourseTabs = (props) => {

  const {
    site,
    handleCultureSampleChange,
    handleSelect,
    handlePathogenSelect,
    handleChange,
    savePathogens,
    patchPathogen,
    checkboxPatchPathogen,
    addNewSusceptibilityTest,
    removeSusceptibilityTests,
    handlePathogenBlur,
    handleSusceptibilityTestBlur,
    chartForReview,
    accordionActiveKey,
    changeAccordionActiveKey,
    savingChartPhase,
  } = props

  const gramNegativePathogenOptions =  [
    {value: 'No culture sample was taken',
    fieldName: 'cultureSampleNotTaken'},
    {value: 'Culture was taken, but no GN pathogen was identified',
    fieldName: 'cultureTakenPathogenNotIdentified'},
    {value: 'Yes',
    fieldName: 'cultureTakenPathogenIdentified'},
  ]

  return (
    <div className="indented-row">
      <SelectWithOptionalTextField
        label='Was a Gram-negative pathogen identified as the indicated GNBI?'
        options={gramNegativePathogenOptions}
        selectFieldName='culture_sample_status'
        selected={site.culture_sample_status}
        handleSelect={handleSelect}
        handleChange={(e, site, options) => handleCultureSampleChange(e, props.site, gramNegativePathogenOptions)}
        disabled={chartForReview}
        placeholder="Please make a selection"
        required={true}
        {...props}
      />

      {
        site.culture_sample_status === 'Yes'
        ?
          <Fragment>
            <PathogenSelection
              site={site}
              handlePathogenSelect={handlePathogenSelect}
              handleChange={handleChange}
              chartForReview={chartForReview}
              handlePathogenBlur={handlePathogenBlur}
              handleSusceptibilityTestBlur={handleSusceptibilityTestBlur}
              savingChartPhase={savingChartPhase}
              handleSavePathogensClick={(site) => savePathogens(props.site)}
              disabled={site.displayPathogenQuestions || chartForReview || savingChartPhase ? true : false}
              {...props}
            />
            {/* <Button 
              disabled={chartForReview} 
              onClick={(site) => savePathogens(props.site)}
            >
              {site.displayPathogenQuestions ? "Edit Pathogens" : "Save Pathogens"}
            </Button> */}
          </Fragment>
        :
          null
      }

      {
        site.displayPathogenQuestions
        ?
          <div className="indented-row" style={{marginTop: "1%"}}>
            <p>Please fill out the following questions for each Pathogen selected:</p>

            <Accordion onSelect={changeAccordionActiveKey}>
              {site.pathogens.map(pathogen => {
                let pathogenNameForHeader
                if (pathogen.name && pathogen.name.toLowerCase() === 'other') {
                  pathogenNameForHeader = (
                    <strong>Other: <i>{pathogen.other_pathogen_description}</i></strong>
                  )
                } else {
                  pathogenNameForHeader = (
                    <strong><i>{formatPathogenName(pathogen.name)}</i></strong>
                  )
                }
                return (
                  <Card key={`pathogen-questions-${pathogen.url}`}>
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey={pathogen.id}>
                        {pathogenNameForHeader} {accordionActiveKey === pathogen.id ? ' (Click To Collapse)' : ' (Click To Expand)'}
                      </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey={pathogen.id}>
                      <Card.Body>
                        <PathogenSpecificQuestions
                          pathogen={pathogen}
                          site={site}
                          handleSelect={handleSelect}
                          patchPathogen={patchPathogen}
                          checkboxPatchPathogen={checkboxPatchPathogen}
                          handlePathogenSelect={handlePathogenSelect}
                          addNewSusceptibilityTest={addNewSusceptibilityTest}
                          removeSusceptibilityTests={removeSusceptibilityTests}
                          handlePathogenBlur={handlePathogenBlur}
                          handleSusceptibilityTestBlur={handleSusceptibilityTestBlur}
                          chartForReview={chartForReview}
                          savingChartPhase={savingChartPhase}
                          {...props}
                        />
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                )
              })}
            </Accordion>
          </div>
        :
        null
      }
    </div>
  )
}

export default InfectionCourseTabs
